import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SidebarToggleService } from 'dhofar-shared-pkg';
import { Subject, takeUntil } from 'rxjs';
import { FooterComponent } from '../footer/footer.component';
import { NavbarComponent } from '../navbar/navbar.component';
import { SidebarComponent } from '../sidebar/sidebar.component';

@Component({
    selector: 'app-layout',
    imports: [RouterOutlet, NavbarComponent, SidebarComponent, FooterComponent],
    templateUrl: './layout.component.html',
    styleUrl: './layout.component.scss'
})
export class LayoutComponent implements OnInit, OnDestroy {
  private sidebarToggleService = inject(SidebarToggleService);
  private destroy$ = new Subject<void>();
  
  isSidebarOpen = false;

  ngOnInit(): void {
    this.sidebarToggleService.isSidebarOpened$
      .pipe(takeUntil(this.destroy$))
      .subscribe(isOpen => {
        this.isSidebarOpen = isOpen;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
